import CredIesNew from "../../assets/img/CredIESNew.svg";
import CredTecNew from "../../assets/img/CredTECNew.svg";
import CredNeoNew from "../../assets/img/CredNeoNew.svg";
import CredNexNew from "../../assets/img/CredNexNew.svg";
import CredIesMedNew from "../../assets/img/CredIESMedNew.svg";
import MaisAcessoNew from "../../assets/img/MaisAcessoNew.svg";

interface ICarouselItem {
  link: string;
  image: string;
}

const staticLink = 'https://instituicao.fundacred.org.br';

export const listCarousel: ICarouselItem[] = [
  {
    link: `${staticLink}/credies`,
    image: CredIesNew
  },
  {
    link: `${staticLink}/credtec`,
    image: CredTecNew
  },
  {
    link: `${staticLink}/credneo`,
    image: CredNeoNew
  },
  {
    link: `${staticLink}/crednex`,
    image: CredNexNew
  },
  {
    link: `${staticLink}/crediesmed`,
    image: CredIesMedNew
  },
  {
    link: `${staticLink}/maisacesso`,
    image: MaisAcessoNew
  },
]